import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                {appData.description}
              </p>
              <div className="grid grid-cols-2 gap-3 mb-6">
                {appData.features.map((feat) => (
                  <div key={feat} className="flex items-center gap-2">
                    <i className="ri-check-line text-sm" style={{ color: 'oklch(var(--primary-500))' }}></i>
                    <span className="text-sm text-foreground-700">{feat}</span>
                  </div>
                ))}
              </div>
              <div className="flex flex-wrap gap-3">
                {appData.platforms.map((p) => (
                  <button
                    key={p.name}
                    className="flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 border"
                    style={{
                      borderColor: 'oklch(var(--background-300))',
                      color: 'oklch(var(--foreground-700))',
                      backgroundColor: 'oklch(var(--background-50))',
                    }}
                  >
                    <i className={`${p.icon} text-base`}></i>
                    {p.name}
                  </button>
                ))}
              </div>
            </div>
            <div className="flex-shrink-0 w-full max-w-sm">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20smartphone%20showing%20a%20manga%20reading%20app%20homepage%20with%20colorful%20comic%20covers%20grid%2C%20soft%20coral%20and%20cream%20gradient%20background%2C%20modern%20flat%20design%2C%20clean%20app%20interface%20mockup%2C%20warm%20ambient%20lighting%2C%20editorial%20quality&width=600&height=800&seq=app-section&orientation=portrait"
                alt="甜柚漫画 APP 界面预览"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}